export default "__VITE_ASSET__DevNtA1X__"